import Box from '@mui/material/Box';
import { Order } from '../../../../models';
import { OrderSummarize } from './OrderSummarize';
import { OrderDetails } from './OrderDetails';

// Order card per Billing 2.0 design: header (summarize) → action band
// (complete payment / repurchase…) → items table → totals.
export const OrderInfo = ({ order, actionItems }: {
  order: Order,
  actionItems?: React.ReactNode,
}) => (
  <Box
    id={`order-${order.id}`}
    sx={theme => ({
      margin: theme.spacing(0, 0, 3, 0),
      backgroundColor: '#FFFFFF',
      border: '1px solid #E1E7E4',
      borderRadius: '16px',
      overflow: 'hidden',
    })}
  >
    {/* Order Summarize */}
    <OrderSummarize order={order} />

    {/* Action band (pending actions / repurchase) */}
    {actionItems}

    {/* Order Details */}
    <OrderDetails order={order} />
  </Box>
);
